import React from "react";

const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_spice-hub-156/artifacts/ar21b12x_RL%20Exports%20Logo.jpeg";

/**
 * Displays the brand logo image. Two variants:
 *  - "light" (dark logo on light backgrounds)
 *  - "dark"  (logo displayed on a subtle light chip so it stays legible)
 */
export const Logo = ({ variant = "light", size = "md", className = "", ...rest }) => {
  const h = size === "lg" ? 64 : size === "sm" ? 40 : 52;

  if (variant === "dark") {
    return (
      <div
        className={`inline-flex items-center ${className}`}
        data-testid="brand-logo"
        {...rest}
      >
        <div className="bg-white/95 px-3 py-1.5 border border-[#D4AF37]/20">
          <img
            src={LOGO_URL}
            alt="Rahilaxmi Exports LLP"
            style={{ height: `${h - 12}px`, width: "auto", objectFit: "contain" }}
            className="block"
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`inline-flex items-center ${className}`}
      data-testid="brand-logo"
      {...rest}
    >
      <img
        src={LOGO_URL}
        alt="Rahilaxmi Exports LLP"
        style={{ height: `${h}px`, width: "auto", objectFit: "contain" }}
        className="block"
      />
    </div>
  );
};

export default Logo;
